import { isDarkPreferred } from '@core/composable/useThemeConfig'
import { themeConfig } from '@themeConfig'

const VALID_DARK_STYLES = ['dark-charcoal', 'dark-steel', 'dark-midnight']

/**
 * Resolves the Vuetify theme name to apply on startup.
 * When the resolved mode is dark, returns the user's preferred dark style
 * from localStorage ('dark-charcoal' by default).
 * Light mode is completely unaffected.
 */
export const resolveVuetifyTheme = () => {
  const storedTheme = localStorage.getItem(`${themeConfig.app.title}-theme`) || themeConfig.app.theme.value

  const isDark = storedTheme === 'system'
    ? isDarkPreferred.value
    : storedTheme === 'dark'

  if (isDark) {
    return resolveDarkStyle()
  }

  return storedTheme === 'system' ? 'light' : storedTheme
}

export const resolveDarkStyle = () => {
  const stored = localStorage.getItem('darkThemeStyle')
  return stored && VALID_DARK_STYLES.includes(stored) ? stored : 'dark-charcoal'
}
